import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Tab, Tabs, Form } from "react-bootstrap";
import { Link } from "gatsby"
import { currencyFormat } from '../../common/utils/site_utlis'
import { defaultArea, defaultArea_Slug } from '../../common/constant'
import { PageLinks } from "../../common/page-links";
import GoogleMap from "../map/google/single"
import { Modal, Button } from 'react-bootstrap';
import _ from "lodash"
import "./ValuationReport.scss";
import Calendar from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { postFormData } from "../forms/api/Api"
import moment from 'moment';
import dateFormat from 'dateformat';


const Valuation = (props) => {

    var mapCoordinates = {
        lat: "51.5169",
        lng: "-0.104733"
    };

    if (!_.isEmpty(props?.comparable_props) && props?.comparable_props?.length > 0) {
        mapCoordinates.lat = props?.comparable_props[0].coords.y;
        mapCoordinates.lng = props?.comparable_props[0].coords.x;
    }
    const [show, setShow] = useState(false);
    const [thankyou, setThanksyou] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [values, setValues] = useState([]);
    // const datePickerRef = useRef()
    useEffect(() => {
        // datePickerRef.current.openCalendar()
    }, [])

    useEffect(() =>{
        if(thankyou){
            window.scrollTo(0, 0)
        }
    },[thankyou])

    const appoinmentSubmit = () => {

        var dates = [];
        if (values) {
            _.map(values, (date) => {
                //dates.push(moment(date?.toDate?.().toString()).utc().format())
                dates.push(dateFormat(date, "isoDate"))
            });
        }
        //console.log("dates==>", dates)
        let formData = new FormData();
        var formValues = {
            "form_name": "leadpro-valuation",
            "form_type": "valuation",
            "form_label": "leadpro-valuation",
            "postcode": props.postcode,
            "address": props.address,
            "first_name": props.first_name,
            "last_name": props.last_name,
            "email": props.email,
            "telephone": props.phone,
            "bedrooms": props.property_bedrooms,
            "proprty_type": props.type,
            "type": props.type,
            "search_type": props.type,
            "formname": "leadpro-valuation",
            "appointment_availability": {
                "hours": dates
            },
            // "source": `${process.env.GATSBY_SITE_NAME} - Website`,
        }
        formData.append('data', JSON.stringify(formValues));

        //console.log("formData ==>", formData);

        postFormData(formData).then(async apiRes => {
            handleClose()
            setThanksyou(true);
            props.setThanks(true);
            props.setResult(null)

            // tracking event
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'formSubmit',
              'formType': 'form-face-to-face-valuation',
              'formId': 'form-face-to-face-valuation',
              'formName': "Face to Face Valuation",
              'formLabel': "Face to Face Valuation - "+formValues.proprty_type
            });
        });
    }

    //console.log("values", values)
    return (
        <React.Fragment>
            <section className="valuation-page">
                <Container>
                    <Row>
                        <Col>
                            <div className="valuation-wrap">
                                {/* {!thankyou &&
                                    <div>
                                        <GoogleMap {...mapCoordinates} height={'300px'} />
                                    </div>
                                } */}
                                {thankyou ?
                                    <div className="valuation-info">
                                        <div className="thankyou">
                                            <h2> Thank you</h2>
                                            <p>One of our property consultants will contact you shortly to confirm your appointment. In the meantime, if you are looking for your next home, you can browse through our selection of exquisite properties.</p>
                                            <Link to={`/${PageLinks.property_to_rent}/in-${defaultArea_Slug}/`} className={'btn'}>Find a Property</Link>
                                        </div>
                                    </div>
                                    :
                                    <div className="valuation-info">
                                        <h5>Valuation Report</h5>
                                        <h2>{props?.address?.replace(/, +/gi, ',').replace(/,+/gi, ', ')}</h2>
                                        <Tabs
                                            defaultActiveKey={props?.type}
                                            id="uncontrolled-tab-example">
                                            <Tab eventKey="vendor" title="Sales">
                                                <div className="valuation-line d-none d-md-flex">
                                                    <span className="circle"></span>
                                                    <span className="circle"></span>
                                                    <span className="circle"></span>
                                                </div>

                                                <div className="valuation-info-wrap">
                                                    <div className="value-info">
                                                        <span className="value">Min Value</span>
                                                        <span className="total">{currencyFormat(props?.minimum_sale_estimation)}</span>
                                                    </div>
                                                    <div className="value-info">
                                                        <span className="value">Est Value</span>
                                                        <strong className="total">{currencyFormat(props?.average_sale_estimation)}</strong>
                                                    </div>
                                                    <div className="value-info">
                                                        <span className="value">Max Value</span>
                                                        <span className="total">{currencyFormat(props?.maximum_sale_estimation)}</span>
                                                    </div>
                                                </div>
                                                

                                                <Button onClick={handleShow}>Book a face-to-face valuation</Button>

                                                <p className="note_text"><b>Please note, this valuation is an estimate.</b> This online valuation was generated automatically using Land Registry data and property listings data. It doesn't take into account any developments made to your property. For a more accurate valuation, please book in a valuation.
                                                </p>

                                            </Tab>

                                            <Tab eventKey="landlord"  title="Lettings">
                                                <div className="valuation-line d-none d-md-flex">
                                                    <span className="circle"></span>
                                                    <span className="circle"></span>
                                                    <span className="circle"></span>
                                                </div>

                                                <div className="valuation-info-wrap">
                                                    <div className="value-info">
                                                        <span className="value">Min Value</span>
                                                        <span className="total">{currencyFormat(props?.minimum_rent_estimation)}</span>
                                                    </div>
                                                    <div className="value-info">
                                                        <span className="value">Est Value</span>
                                                        <strong className="total">{currencyFormat(props?.average_rent_estimation)}</strong>
                                                    </div>
                                                    <div className="value-info">
                                                        <span className="value">Max Value</span>
                                                        <span className="total">{currencyFormat(props?.maximum_rent_estimation)}</span>
                                                    </div>
                                                </div>
                                                <Button onClick={handleShow}>Book a face-to-face valuation</Button>
                                                <p className="note_text">
                                                    Please note, your property is unique and this valuation is an estimate only. This online property valuation was generated automatically using Land Registry data and property listings data. It doesn't take into account any
                                                    developments made to your property.
                                                </p>

                                            </Tab>
                                        </Tabs>
                                    </div>
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Modal show={show} onHide={handleClose}
                backdrop="static"
                // centered
                dialogClassName="modal-appointment-form"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Select a preferred date (not guaranteed)</Modal.Title>
                </Modal.Header>
                <Form action="javascript:;" onSubmit={appoinmentSubmit}>
                    <Modal.Body>
                        <h5>Choose your preferred appointment date below and a member of our team will contact you shortly to confirm availability.</h5>
                        {process.env.GATSBY_SITE_NAME === "Linley and Simpson" ?
                            <Calendar
                                value={values}
                                onChange={setValues}
                                minDate={new Date()}
                                format="DD/MMM/YYYY"
                                multiple
                                inputClass="form-control"
                                placeholder="Select appointment date"
                                plugins={[
                                    // <TimePicker position="bottom" hideSeconds className="valuation-time-picker"/>,
                                    <DatePanel markFocused />
                                ]}
                                required={true}
                                mapDays={({ date }) => {
                                    let isSunday = date.weekDay.index === 0; // 0 = Sunday
                                    if (isSunday) {
                                    return {
                                        disabled: true,
                                        style: { color: "#ccc"},
                                    };
                                    }
                                }}
                                // onClose={() => false} 
                            />
                        :
                            <Calendar
                                // ref={datePickerRef}
                                value={values}
                                onChange={setValues}
                                minDate={new Date()}
                                //format="DD/MMM/YYYY hh:mm A"
                                format="DD/MMM/YYYY"
                                multiple
                                inputClass="form-control"
                                placeholder="Select appointment date"
                                plugins={[
                                    // <TimePicker position="bottom" hideSeconds className="valuation-time-picker"/>,
                                    <DatePanel markFocused />
                                ]}
                                required={true}
                                // onClose={() => false} 
                            />
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="submit">Submit</Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </React.Fragment >
    );
};
export default Valuation;
